import React from 'react';
import PropTypes from 'prop-types';

import RBICookiePolicyComponent from './children/RBICookiePolicyComponent/RBICookiePolicyComponent';
import EUPersonalizedAdsOptIn from './children/EUPersonalizedAdsOptIn/EUPersonalizedAdsOptIn';
import AdsInitialSettings from './children/AdsInitialSettings/AdsInitialSettings';
import { getCountry, toggleEUOptInBanner, toggleHasDeterminedPersonalizedAds } from '../../../redux/actions';
import { getProfile, updateProfile } from '../../../../Account/redux/actions';
import { createCookie } from '../../../../../src/utils/createCookie';
import { readCookie } from '../../../../../src/utils/readCookie';
import {
  set as gtagSet,
  userHasOptedIntoPersonalizedAds,
} from '../../../../../shared/lib/google-global-site-tag/index';
import componentBase from '../../../../../src/lib/component-base';

@componentBase('EUCompliance')
export default class EUCompliance extends React.Component {
  static propTypes = {
    country: PropTypes.string,
    dispatch: PropTypes.func,
    hasDeterminedPersonalizedAds: PropTypes.bool,
    finishedCountryFetch: PropTypes.bool,
    showEUOptInBanner: PropTypes.bool,
    user: PropTypes.object,
  }

  componentDidMount() {
    const { dispatch, user } = this.props;
    if (user) {
      dispatch(getProfile());
    }
    dispatch(getCountry());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(toggleEUOptInBanner(false));
  }

  cookieName = 'fs-personalized-ads-opt-in';

  EUOptInCallback = (bool) => {
    const { dispatch, user } = this.props;

    if (user) {
      // user exists, update profile with opt in information
      const profileWithOptInInformation = {
        ...user.profile,
        optInPersonalizedAds: bool, // new stuff
      };
      const updatedUser = {
        ...user,
        profile: profileWithOptInInformation,
      };
      dispatch(updateProfile(updatedUser));
    }

    const label = bool ? 'PersonalizedAdsYes' : 'PersonalizedAdsNo';
    // report to ga
    this.reportUserEvent({
      action: 'ButtonPress',
      label,
      value: null,
    });

    createCookie({
      name: this.cookieName,
      value: `${bool}`,
      days: 18250, // same amount of days as rbi cookie component aka 50 years
    });
    // dispatch and make the component go away
    dispatch(toggleHasDeterminedPersonalizedAds({
      value: bool,
      hasDeterminedPersonalizedAds: true,
    }));
    dispatch(toggleEUOptInBanner(false));
  }

  isTrueSet = val => (val === 'true');

  toggleAdOptIn = ({ show }) => {
    const { country, dispatch, user } = this.props;
    const isInEEA = this.isInEEA(country);
    const optInSelection = user && userHasOptedIntoPersonalizedAds(user);
    const cookieVal = readCookie({ name: this.cookieName });
    if (isInEEA) {
      if (cookieVal) { // string "true" or "false"
        // cookie has been set already, no need to show a banner that sets it
        dispatch(toggleEUOptInBanner(false));
        const value = this.isTrueSet(cookieVal);
        dispatch(toggleHasDeterminedPersonalizedAds({
          hasDeterminedPersonalizedAds: true,
          value,
        }));
      } else if (
        (optInSelection === undefined) || // when the user has not selected yet
        (optInSelection === null) // when there is no user
      ) {
        dispatch(toggleEUOptInBanner(true));
      } else if (user) {
        dispatch(toggleHasDeterminedPersonalizedAds({
          hasDeterminedPersonalizedAds: true,
          value: optInSelection,
        }));
        dispatch(toggleEUOptInBanner(false));
      } else if (show) {
        dispatch(toggleEUOptInBanner(true));
      } else {
        dispatch(toggleEUOptInBanner(false));
      }
    }
  };

  reportUserEvent = ({ action, label, value }) => {
    this.context.reportUserEvent(
      action,
      label,
      value,
    );
  }

  reportPersonalizedAds = bool => gtagSet({ PersonalizedAds: `${bool}` });

  // https://support.google.com/dfp_premium/answer/7678538
  eea = ['at', 'be', 'bg', 'cy', 'cz', 'de', 'dk', 'ee', 'es', 'fi', 'fr',
    'gb', 'gr', 'hr', 'hu', 'ie', 'is', 'it', 'li', 'lt', 'lu', 'lv', 'mt', 'nl',
    'no', 'pl', 'pt', 'ro', 'se', 'si', 'sk']; // european economic area

  isInEEA = twoLetterCode => this.eea.includes(twoLetterCode && twoLetterCode.toLowerCase());

  render() {
    const {
      country,
      dispatch,
      hasDeterminedPersonalizedAds,
      finishedCountryFetch,
      showEUOptInBanner,
      user,
    } = this.props;
    const isInEEA = this.isInEEA(country);

    return (
      <React.Fragment>
        {
          isInEEA &&
          <RBICookiePolicyComponent
            onUnmount={() => this.toggleAdOptIn({ show: true })}
          />
        }
        {
          isInEEA &&
          <EUPersonalizedAdsOptIn
            cookieName={this.cookieName}
            dispatch={dispatch}
            selectionCallback={this.EUOptInCallback}
            show={showEUOptInBanner}
            user={user}
          />
        }
        {
          finishedCountryFetch &&
          hasDeterminedPersonalizedAds &&
          /*
            isInEEA should not be a pre-check,
            depending on whether a country is or is not in the EU,
            AdsInitialSettings component will report a dimension to elgoog
          */
          <AdsInitialSettings
            cookieName={this.cookieName}
            isInEEA={isInEEA}
            reportPersonalizedAds={this.reportPersonalizedAds}
            user={user}
          />
        }
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/App/components/children/EUCompliance/EUCompliance.js